// @flow
// DEPRECATED
// известные типы покупателей, но запрос может возвращать и другие
export const EMPLOYEE_COMMON: 'Сотрудники ОУ' = 'Сотрудники ОУ';
export const EMPLOYEE_CAFE: 'Сотрудники КШП' = 'Сотрудники КШП';
export const STUDENT: 'Учащиеся' = 'Учащиеся';
export const EMPLOYEE: 'Сотрудники' = 'Сотрудники';
